import ImpactDirectionByGgVar from './ImpactDirectionByGgVar';
export default ImpactDirectionByGgVar;
